import { doc as docFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name doc_node
 */

export var doc = docFactory({});